import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';

import { GuidelineService } from '../../../services/guideline.service';
import { ToastComponent } from '../../toast/toast.component';
import { Guideline } from '../../models/guideline.model';
import { ee, guidelineDepartments } from '../../constants';
import { setClassInvalidTpl } from '../../functions';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-edit-guideline-modal',
  templateUrl: './edit-guideline-modal.component.html',
  standalone: false
})
export class EditGuidelineModalComponent implements OnInit, OnDestroy {
  toast = inject(ToastComponent);
  private guidelineService = inject(GuidelineService);


  @Input() guideline: Guideline;

  guidelineDepartments = guidelineDepartments;
  setClassInvalidTpl = setClassInvalidTpl;

  ngOnInit(): void {
    // This is executed N+1 times, to fix eventually
    ee.on('showEditGuidelineModal', (guideline: Guideline) => this.guideline = guideline);
  }

  ngOnDestroy(): void {
    ee.off('showEditGuidelineModal', () => {});
  }

  updateGuideline(guideline: Guideline): void {
    this.guidelineService.update(guideline)
      .pipe(finalize(() => ee.emit('getGuidelines')))
      .subscribe({
        next: res => this.toast.setMessage('Guideline updated successfully', 'success'),
        error: err => this.toast.setMessage(err.error.message, 'danger'),
      });
  }

}
